// This file is auto-generated don't edit it!
import { Component } from '@angular/core';

@Component({
    selector: 'ui-alert-dialog-docs',
    templateUrl: './alert-dialog.docs.generated.html',
})
export class UIAlertDialogDocs { }
